import { render, staticRenderFns } from "./CrearCalendarioModal.vue?vue&type=template&id=ebab2fa4&"
import script from "./CrearCalendarioModal.vue?vue&type=script&lang=ts&"
export * from "./CrearCalendarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ebab2fa4', component.options)
    } else {
      api.reload('ebab2fa4', component.options)
    }
    module.hot.accept("./CrearCalendarioModal.vue?vue&type=template&id=ebab2fa4&", function () {
      api.rerender('ebab2fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Calendarios/CrearCalendarioModal.vue"
export default component.exports